@if (!inlineRadio()) {
  <input
    [formControl]="formControl"
    [id]="id()"
    [value]="value()"
    type="radio"
    class="btn-check"
  />
  <label
    [for]="id()"
    class="btn btn-outline btn-outline-dashed btn-active-light-primary p-7 d-flex align-items-center h-100"
  >
    <ui-keenicon [name]="iconName()" class="fs-3x me-5"></ui-keenicon>
    <span class="d-block fw-semibold text-start">
      <span class="text-gray-900 fw-bold d-block fs-4 mb-2">{{ name() }}</span>
      <span class="text-muted fw-semibold fs-6">{{ description() }}</span>
    </span>
  </label>
}
@if (inlineRadio()) {
  <label class="d-flex flex-stack mb-5 cursor-pointer">
    <span class="d-flex align-items-center me-2">
      @if (iconName()) {
        <span class="symbol symbol-50px me-6">
          <span class="symbol-label">
            <ui-keenicon [name]="iconName()" class="fs-1"></ui-keenicon>
          </span>
        </span>
      }
      <span class="d-flex flex-column">
        <span class="fw-bolder text-gray-800 text-hover-primary fs-5">
          {{ name() }}
        </span>
        <span class="fs-6 fw-bold text-gray-500">
          {{ description() }}
        </span>
      </span>
    </span>
    <span class="form-check form-check-custom form-check-solid">
      <input
        class="form-check-input"
        type="radio"
        [formControl]="formControl"
        [id]="id()"
        [value]="value()"
      />
    </span>
  </label>
}
